import {
    ref,
    Ref,
    computed,
    onMounted,
    nextTick,
    onBeforeUnmount,
    ComponentInternalInstance,
} from 'vue'
import { TableProps, ColumnProps } from 'ant-design-vue/lib/table/interface'

export function useTableScroll(instance: ComponentInternalInstance | null) {
    let tableElRef: TableProps & { $el: HTMLElement } // a-table 实例
    let tableEl: HTMLElement // dom
    let columns: ColumnProps // 表头

    const minHeight: number = 300
    const paginationHeight: number = 48
    const theadHeight: number = 44
    const tableHeight: Ref<number | string> = ref('max-content')
    const tableWidth: Ref<number> = ref(0)
    let timer: any

    const setHeight = async () => {
        let extraArray: Array<number> = [theadHeight, paginationHeight]
        const height =
            minHeight < tableEl.offsetHeight ? tableEl.offsetHeight : minHeight
        tableHeight.value =
            height -
            extraArray.reduce((m, n) => {
                return m + n
            })
    }

    // 计算当前的table高度
    const calcHeight = () => {
        clearTimeout(timer)
        timer = setTimeout(() => {
            setHeight()
        }, 500)
    }
    const calcWidth = () => {
        if (Array.isArray(columns)) {
            return columns.reduce((prev, next) => {
                return prev + Number(next?.width) || 80
            }, 0)
        }
        return 0
    }

    onMounted(() => {
        nextTick(() => {
            const refs: any = instance?.proxy?.$refs
            tableElRef = refs?.tableElRef
            if (tableElRef) {
                tableEl = tableElRef?.$el
                if (tableElRef.columns) {
                    columns = tableElRef?.columns
                }
                calcHeight()
                tableWidth.value = calcWidth()
                window.addEventListener('resize', calcHeight)
            }
        })
    })

    onBeforeUnmount(() => {
        window.removeEventListener('resize', calcHeight)
    })

    const scroll = computed(() => {
        return {
            x: tableWidth.value,
            y: tableHeight.value,
        }
    })

    return {
        scroll,
        tableWidth,
        tableHeight,
        calcHeight,
    }
}
